import { toast } from '@gmg/gmg-react-components';
import { TFunction } from 'i18next';
import { LicenseSystemChangedChangeType, LicenseSystemChangedPayload } from '../generated/types';
import { getTransferToastContent } from './getTransferToastContent';

export const showLicenseSystemChangedToast = (event: LicenseSystemChangedPayload, t: TFunction) => {
    if (!event.messageId) return;

    switch (event.changeType) {
        case LicenseSystemChangedChangeType.TransferStarted:
        case LicenseSystemChangedChangeType.TransferAccepted:
            toast.loading(getTransferToastContent(t, 'loading', event.sourceLicenseSystemId || undefined), { id: event.messageId });
            break;
        case LicenseSystemChangedChangeType.TransferCompleted:
            toast.success(getTransferToastContent(t, 'success', event.sourceLicenseSystemId || undefined), { id: event.messageId });
            break;
        case LicenseSystemChangedChangeType.TransferFailed:
            toast.error(getTransferToastContent(t, 'failed', event.sourceLicenseSystemId || undefined), { id: event.messageId });
            break;

        case LicenseSystemChangedChangeType.ReactivateLicenseSystemStarted:
        case LicenseSystemChangedChangeType.ReactivateLicenseSystemCompleted:
        case LicenseSystemChangedChangeType.ReactivateLicenseSystemFailed:
        case LicenseSystemChangedChangeType.AddLicenseSystemStarted:
        case LicenseSystemChangedChangeType.AddLicenseSystemCompleted:
        case LicenseSystemChangedChangeType.AddLicenseSystemFailed:
            break;
    }
};
